export function between(string, left, right = null) {
    const leftIndex = string.indexOf(left);
    if(leftIndex === -1) {
        return null;
    }
    const stringWithoutLeft = string.substring(leftIndex + left.length);
    if(right === null) {
        return stringWithoutLeft
    }
    else {
        const rightIndex = stringWithoutLeft.indexOf(right);
        return stringWithoutLeft.substring(rightIndex);
    }
}
